import { ref } from 'vue';

/**
 * This function provides crop related controls
 * @returns {array}
 * @example{
 *    const [crop, cropperDialogRef] = useCropImage();
 *
 *    return[
 *      crop: This function takes the image and returns the image and its cropped states
 *      cropperDialogRef: Reference of ImageCropperDialog component
 *    ]
 * }
 */
const useCropImage = () => {
  const cropperDialogRef = ref(null);

  const crop = async image => {
    const images = [image.path];
    const croppedImages = await cropperDialogRef.value.openCropper(images);

    return {
      ...image,
      crops: croppedImages && [...croppedImages],
    };
  };

  return [
    crop,
    cropperDialogRef,
  ];
};

export default useCropImage;
